import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableFooter from "@material-ui/core/TableFooter";
import TableContainer from '@material-ui/core/TableContainer'

import style from "assets/jss/material-kit-pro-react/components/tableStyle.js";

const styles = {
  ...style,
  container : {
    maxHeight : 400,
  },
  stickyHead : {
    position : "sticky",
    top : 0,
    zIndex : 10,
    backgroundColor : '#fff',
    color : '#000',
  },
  stickyFoot : {
    position : "sticky",
    bottom : 0,
    zIndex : 10,
    backgroundColor : '#fff',
    color : '#000',
    fontWeight : 'bold'
  }
} 

const useStyles = makeStyles(styles);

export default function CustomTable(props) {
  const {
    tableHead,
    tableFoot,
    tableData,
    tableHeaderColor,
    tableFooterColor,
    hover,
    colorsColls,
    coloredColls,
    customCellClasses,
    customClassesForCells,
    striped,
    tableShopping,
    customHeadCellClasses,
    customHeadClassesForCells,
    customFootCellClasses,
    customFootClassesForCells
  } = props;
  const classes = useStyles();
  return (
    <div className={classes.tableResponsive}>
      <TableContainer className={classes.container}>
        <Table stickyHeader className={classes.table}>
          {tableHead !== undefined ? (
            <TableHead className={classes[tableHeaderColor]}>
              <TableRow className={classes.tableRow}>
                {tableHead.map((prop, key) => {
                  const tableCellClasses =
                    classes.stickyHead +
                    " " +
                    classes.tableHeadCell +
                    " " +
                    classes.tableCell +
                    " " +
                    cx({
                      [customHeadCellClasses[
                        customHeadClassesForCells.indexOf(key)
                      ]]: customHeadClassesForCells.indexOf(key) !== -1,
                      [classes.tableShoppingHead]: tableShopping
                    });
                  return (
                    prop?
                    <TableCell className={tableCellClasses} key={key}>
                      {prop}
                    </TableCell>:null
                  );
                })}
              </TableRow>
            </TableHead>
          ) : null}
          <TableBody>
            {tableData.map((prop, key) => {
              var rowColor = "";
              var rowColored = false;
              if (prop.color !== undefined) {
                rowColor = prop.color;
                rowColored = true;
                prop = prop.data;
              }
              const tableRowClasses = cx({
                [classes.tableRowHover]: hover,
                [classes[rowColor + "Row"]]: rowColored,
                [classes.tableStripedRow]: striped && key % 2 === 0
              });
              if (prop.total) {
                return (
                  <TableRow key={key} hover={hover} className={tableRowClasses}>
                    <TableCell
                      className={classes.tableCell}
                      colSpan={prop.colspan}
                    />
                    <TableCell
                      className={classes.tableCell + " " + classes.tableCellTotal}
                    >
                      Total
                    </TableCell>
                    <TableCell
                      className={
                        classes.tableCell + " " + classes.tableCellAmount
                      }
                    >
                      {prop.amount}
                    </TableCell>
                    {tableHead.length - (prop.colspan - 0 + 2) > 0 ? (
                      <TableCell
                        className={classes.tableCell}
                        colSpan={tableHead.length - (prop.colspan - 0 + 2)}
                      />
                    ) : null}
                  </TableRow>
                );
              }
              if (prop.purchase) {
                return (
                  <TableRow key={key} hover={hover} className={tableRowClasses}>
                    <TableCell
                      className={classes.tableCell}
                      colSpan={prop.colspan}
                    />
                    <TableCell
                      className={classes.tableCell + " " + classes.tableCellTotal}
                    >
                      Total
                    </TableCell>
                    <TableCell
                      className={
                        classes.tableCell + " " + classes.tableCellAmount
                      }
                    >
                      {prop.amount}
                    </TableCell>
                    <TableCell
                      className={classes.tableCell + " " + classes.right}
                      colSpan={prop.col.colspan}
                    >
                      {prop.col.text}
                    </TableCell>
                  </TableRow>
                );
              }
              return (
                <TableRow
                  key={key}
                  hover={hover}
                  className={classes.tableRow + " " + tableRowClasses}
                >
                  {prop.map((prop, key) => {
                    const tableCellClasses =
                      classes.tableCell +
                      " " +
                      cx({
                        [classes[colorsColls[coloredColls.indexOf(key)]]]:
                          coloredColls.indexOf(key) !== -1,
                        [customCellClasses[customClassesForCells.indexOf(key)]]:
                          customClassesForCells.indexOf(key) !== -1
                      });
                    return (
                      prop?
                      <TableCell className={tableCellClasses} key={key}>
                        {prop}
                      </TableCell>:''
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
          {tableFoot !== undefined ? (
            <TableFooter className={classes[tableFooterColor]}>
              <TableRow className={classes.tableRow}>
                {tableFoot.map((prop, key) => {
                  const tableCellClasses =
                    classes.stickyFoot +
                    " " +
                    classes.tableFootCell +
                    " " +
                    classes.tableCell +
                    " " +
                    cx({
                      [customFootCellClasses[
                        customFootClassesForCells.indexOf(key)
                      ]]: customFootClassesForCells.indexOf(key) !== -1,
                      [classes.tableShoppingFoot]: tableShopping
                    });
                  return (
                    prop?
                    <TableCell className={tableCellClasses} key={key}>
                      {prop}
                    </TableCell>:null
                  );
                })}
              </TableRow>
            </TableFooter>
          ) : null}
        </Table>
      </TableContainer>
    </div>
  );
}

CustomTable.defaultProps = {
  tableHeaderColor: "gray",
  tableFooterColor: "gray",
  hover: false,
  colorsColls: [],
  coloredColls: [],
  striped: false,
  customCellClasses: [],
  customClassesForCells: [],
  customHeadCellClasses: [],
  customHeadClassesForCells: [],
  customFootCellClasses: [],
  customFootClassesForCells: []
};

CustomTable.propTypes = {
  tableHeaderColor: PropTypes.oneOf([
    "warning",
    "primary",
    "danger",
    "success",
    "info",
    "rose",
    "gray"
  ]),
  tableHead: PropTypes.arrayOf(PropTypes.string),
  // Of(PropTypes.arrayOf(PropTypes.node)) || Of(PropTypes.object),
  tableData: PropTypes.array,
  tableFoot: PropTypes.arrayOf(PropTypes.string),
  hover: PropTypes.bool,
  coloredColls: PropTypes.arrayOf(PropTypes.number),
  // Of(["warning","primary","danger","success","info","rose","gray"]) - colorsColls
  colorsColls: PropTypes.array,
  customCellClasses: PropTypes.arrayOf(PropTypes.string),
  customClassesForCells: PropTypes.arrayOf(PropTypes.number),
  customHeadCellClasses: PropTypes.arrayOf(PropTypes.string),
  customHeadClassesForCells: PropTypes.arrayOf(PropTypes.number),
  customFootCellClasses: PropTypes.arrayOf(PropTypes.string),
  customFootClassesForCells: PropTypes.arrayOf(PropTypes.number),
  striped: PropTypes.bool,
  // this will cause some changes in font
  tableShopping: PropTypes.bool
};
